import { connect } from 'react-redux';
import LoginForm from './LoginForm';

import { logInUser } from '../../actions/currentUserAction';

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
});
const mapDispachToProps = (dispatch) => ({
  onLogin: ({ username, password }) => dispatch(logInUser({ username, password })),
});

export default connect(mapStateToProps, mapDispachToProps)(LoginForm);
